module.exports = __webpack_public_path__ + "2c65959514085ff33f7418052cfe4e95.png";